import React from 'react';
import {LoaderWrapper,Loader,LoaderInner} from './styleLoadScreen';
export default function LoadingScreen(props){
    return(
        <LoaderWrapper display={props.display} position={props.position} background={props.background} >
            <Loader>
                <LoaderInner></LoaderInner>
            </Loader>
        </LoaderWrapper>
    )
}
